

























import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { VideoPostSettings } from "@/services/posts/postTypes/video";

@Component
export default class VideoSettings extends Vue {
    @Prop() postSettings!: VideoPostSettings;
    @Prop() styleOptions!: Style[];
    @Prop() isNew!: boolean;

    defaultValues = { styleId: "", allowCaption: true, allowSound: true } as VideoPostSettings;
    localPostSettings = { ...this.defaultValues, ...JSON.parse(JSON.stringify(this.postSettings)) } as VideoPostSettings;

    mounted() {
        this.setDefaultStyle();
    }

    setDefaultStyle() {
        const styles = this.styleOptions.filter(x => x.id); // Exclude the "no style" option
        if (styles.length > 0 && this.isNew) {
            const defaultStyle = styles.filter(x => x.name.toLowerCase().includes("default"))[0];
            this.localPostSettings.styleId = defaultStyle ? defaultStyle.id : styles[0].id;
        }
    }

    emitData() {
        this.$emit("allowedPostSettingsUpdated", this.localPostSettings);
    }
}
